export const Kapyl = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.19639929964427, 52.93630905514942],
            [27.188345851496592, 52.937765183575266],
            [27.18120359281096, 52.939648366173174],
            [27.178525246028414, 52.94475944952973],
            [27.178525246028414, 52.95578657170279],
            [27.176739680907758, 52.964928883049026],
            [27.175846899245812, 52.97111229125579],
            [27.173614943294183, 52.97810116586055],
            [27.170043813951395, 52.9821326946776],
            [27.164687120386418, 52.985895115701055],
            [27.158226232945367, 52.98659295514295],
            [27.15274097878512, 52.98670302634861],
            [27.14963266776482, 52.988904386693264],
            [27.150729719135825, 52.992646442511216],
            [27.155849289805246, 52.99715849031486],
            [27.15914044212178, 52.99990950726192],
            [27.16115170266943, 53.003870664197336],
            [27.15950612561278, 53.00772144033709],
            [27.155300764119772, 53.00992172992335],
            [27.152558136590415, 53.01355196208908],
            [27.15310666227589, 53.021691372821294],
            [27.156397815490777, 53.027410040095276],
            [27.17272216073394, 53.03021325014225],
            [27.182096375371202, 53.03021325014225],
            [27.19013141571878, 53.03021325014225],
            [27.196827282675144, 53.031555513731064],
            [27.203076758800535, 53.033971482592335],
            [27.20664788814338, 53.03826620451139],
            [27.205947946925107, 53.041703391680585],
            [27.207410681787053, 53.044671416378094],
            [27.214541512105654, 53.04774915285407],
            [27.218564032302254, 53.05082666903053],
            [27.218198348811427, 53.05500294679041],
            [27.212895935947472, 53.058739272926005],
            [27.20667931480517, 53.06214564121444],
            [27.20137690194116, 53.065551740168246],
            [27.198085748726328, 53.069726590792015],
            [27.199182800097333, 53.072912388860914],
            [27.204850896452285, 53.07598810797356],
            [27.21234741026177, 53.076207793712],
            [27.225877704815503, 53.07598810797356],
            [27.231545801170455, 53.0768668447414],
            [27.238310948896412, 53.07763572449909],
            [27.245076095724187, 53.080820937452415],
            [27.250195666393665, 53.083676445135325],
            [27.256777971925032, 53.08543358635916],
            [27.262080384788987, 53.087190655851884],
            [27.271588159146006, 53.086092495622495],
            [27.2772562555009, 53.083676445135325],
            [27.28201014267944, 53.082248714701734],
            [27.286946871154328, 53.082248714701734],
            [27.295906120724112, 53.083676445135325],
            [27.30413400241366, 53.087190655851884],
            [27.30523105288654, 53.09059477417759],
            [27.30523105288654, 53.09487699239281],
            [27.30285410974642, 53.097951142391025],
            [27.297551696882294, 53.102342404302306],
            [27.29645464551129, 53.10475740747785],
            [27.2977345381787, 53.10662345286363],
            [27.303219793237247, 53.10805037472255],
            [27.30870504739761, 53.108818697486356],
            [27.315287352929033, 53.108489417828594],
            [27.32095544928393, 53.10629415693694],
            [27.32333239242405, 53.10607462473865],
            [27.329000488779002, 53.10717227452449],
            [27.33119459062283, 53.10914797462311],
            [27.33247448329024, 53.111891851278415],
            [27.334668585133898, 53.11331859833649],
            [27.337959738348786, 53.113647840478336],
            [27.342165099841736, 53.113428345817454],
            [27.347650354002155, 53.113647840478336],
            [27.352769924671577, 53.11518427280993],
            [27.356792444868177, 53.11704986579133],
            [27.358986546712003, 53.11902511209473],
            [27.360997806361183, 53.12078080997924],
            [27.363374750399544, 53.12154890528927],
            [27.369042846754496, 53.12275588432169],
            [27.373979575229384, 53.1230850547355],
            [27.37909914679716, 53.1230850547355],
            [27.383304508290166, 53.123853108871856],
            [27.385864293624763, 53.12747375073377],
            [27.38769271197765, 53.13021645850381],
            [27.392629440452424, 53.1330686885737],
            [27.397749012020142, 53.13405595476854],
            [27.40579405151516, 53.13449473234266],
            [27.41018225520287, 53.13449473234266],
            [27.416216035048762, 53.13405595476854],
            [27.421152764421834, 53.13328808296205],
            [27.42828359474038, 53.13241049814815],
            [27.436145792939158, 53.13219109927894],
            [27.440533996626698, 53.13394625940538],
            [27.44254525627605, 53.136907929982044],
            [27.44272809847058, 53.13921131015525],
            [27.439985470941224, 53.14337901764543],
            [27.43852273607928, 53.1452433875329],
            [27.439254103959286, 53.14853325427214],
            [27.44254525627605, 53.15182286953285],
            [27.44569927806947, 53.15290564572956],
            [27.450841703676247, 53.153933572691926],
            [27.45798396236205, 53.157017206460694],
            [27.461983626722827, 53.160443205844615],
            [27.46369776859177, 53.16421148990224],
            [27.465697601670456, 53.16712311875722],
            [27.46798312416246, 53.16952078297197],
            [27.46855450478563, 53.17363075188791],
            [27.46741174353963, 53.176199283084145],
            [27.465697601670456, 53.17911009859881],
            [27.463983458903385, 53.18116467352502],
            [27.46055517516544, 53.18441754837471],
            [27.45684120111605, 53.18647186907543],
            [27.45141308429919, 53.188526090831715],
            [27.447413419938414, 53.19126490010086],
            [27.448270490872858, 53.19434585196444],
            [27.452270155233805, 53.19691314228021],
            [27.456555510804435, 53.198795724670845],
            [27.461126555788383, 53.19913800339742],
            [27.46798312416246, 53.19930914173597],
            [27.47912504720904, 53.20050709097302],
            [27.481981950323984, 53.20238951498686],
            [27.486552996206285, 53.20564078045612],
            [27.495409396760863, 53.210260574751715],
            [27.50169458361364, 53.2143666409836],
            [27.507408390741887, 53.2152220218054],
            [27.51169374541422, 53.2152220218054],
            [27.518836004099853, 53.2152220218054],
            [27.523121358772244, 53.215906314165636],
            [27.527978094966045, 53.21744593254897],
            [27.53140637870382, 53.22103815899504],
            [27.53140637870382, 53.22326176778813],
            [27.526549643408487, 53.226682478137775],
            [27.5228356684608, 53.22890579387894],
            [27.517978933165466, 53.231128993641846],
            [27.516836171919465, 53.23352307967281],
            [27.516836171919465, 53.23762691622534],
            [27.516550481607908, 53.240875507928536],
            [27.51426495821778, 53.24412385253356],
            [27.508265461676274, 53.24651721184432],
            [27.502837344859586, 53.24651721184432],
            [27.498472910594444, 53.24534407233057],
            [27.494143216876182, 53.24268312244578],
            [27.488175260184505, 53.24079234669665],
            [27.484196621791227, 53.24037216308324],
            [27.474725416052763, 53.244048630370855],
            [27.46357206553745, 53.24809675622049],
            [27.4549785003569, 53.251050551745664],
            [27.450773137965598, 53.25345719774566],
            [27.446019250787117, 53.2575044329717],
            [27.44254525627605, 53.26089506518974],
            [27.44254525627605, 53.263629250482836],
            [27.445105041610645, 53.26614454613474],
            [27.446384934278058, 53.268769044960834],
            [27.443642307646996, 53.271830756477186],
            [27.439071261764752, 53.273252191171366],
            [27.43157474795521, 53.27303351157377],
            [27.42554096721102, 53.27412689622662],
            [27.417678769910708, 53.27686023550899],
            [27.41548466806688, 53.27904678055501],
            [27.415850351557822, 53.28210775602207],
            [27.419690029559888, 53.28276365112043],
            [27.425358125914784, 53.282982280403644],
            [27.431209063566143, 53.28363816207974],
            [27.437608527801103, 53.28516851279255],
            [27.440351154432165, 53.28669880869893],
            [27.441631047099577, 53.289322045756535],
            [27.44181388929411, 53.292054412781454],
            [27.436511476430155, 53.293584462068736],
            [27.43157474795521, 53.29555158815367],
            [27.429014961722316, 53.29686295450057],
            [27.426455176387663, 53.3011246189555],
            [27.426089492896722, 53.30636916051384],
            [27.42334686626566, 53.31008365395593],
            [27.422249814894656, 53.314125530337094],
            [27.4206001129765, 53.316260876558886],
            [27.42005571305083, 53.31696553860206],
            [27.411644990064815, 53.31816702348914],
            [27.392812282647128, 53.31707476560587],
            [27.37196831558026, 53.31674708321924],
            [27.352404241180636, 53.3175116724355],
            [27.341068048470788, 53.317948574256036],
            [27.334668585133898, 53.3193684750899],
            [27.327903438306294, 53.320897545904074],
            [27.3218696584604, 53.323409471800346],
            [27.316201562105448, 53.32526601785514],
            [27.311081991436026, 53.32679487735584],
            [27.30523105288654, 53.32745008585573],
            [27.2977345381787, 53.325484429632695],
            [27.294077702371226, 53.322208134501864],
            [27.290420865665396, 53.31838547160419],
            [27.285118453699738, 53.31467170051036],
            [27.279267515150252, 53.30953742561445],
            [27.263543118752636, 53.304074752974714],
            [27.25696081322127, 53.302872870866565],
            [27.247453038864307, 53.302108019428715],
            [27.240687892036647, 53.300141195836545],
            [27.2330085360324, 53.29861138140819],
            [27.22423212865715, 53.29828355674795],
            [27.209970467121707, 53.299267022643164],
            [27.196257331271738, 53.30571362777641],
            [27.182909878014414, 53.31303316902489],
            [27.165722747653206, 53.3218804909917],
            [27.15950612561278, 53.32526601785514],
            [27.15493508062883, 53.329088063888946],
            [27.15402087145236, 53.33312814018592],
            [27.15365518796159, 53.33869626740284],
            [27.1543865549433, 53.34186213316951],
            [27.153838029257827, 53.34841145349384],
            [27.14963266776482, 53.3510309001573],
            [27.145061622780872, 53.35124918002458],
            [27.1373822658785, 53.349393765256934],
            [27.133359746580027, 53.34764741794254],
            [27.129154384188723, 53.346774217995176],
            [27.124217655714006, 53.34644676313587],
            [27.119463768535525, 53.346228458677786],
            [27.11489272265328, 53.34470029563727],
            [27.111601570336745, 53.341643804701164],
            [27.110321677669504, 53.33978797187666],
            [27.107030525352968, 53.33749536052471],
            [27.102642321665257, 53.33684030576603],
            [27.09642569962483, 53.337932057749924],
            [27.090940445464412, 53.34033381363355],
            [27.08618655828593, 53.341207145483395],
            [27.080701303227215, 53.34142547565119],
            [27.078141517892618, 53.340006309310525],
            [27.074850365576083, 53.33782288359453],
            [27.071010687574017, 53.334329170570754],
            [27.067536693062948, 53.33072597903521],
            [27.064611223338886, 53.328105284830144],
            [27.061137228827818, 53.3259212498337],
            [27.057114709529344, 53.32406473228906],
            [27.05016672050698, 53.32242656193199],
            [27.043218731484842, 53.32067911064735],
            [27.038647685602598, 53.32046067373574],
            [27.034990849795065, 53.320897545904074],
            [27.031882538774937, 53.32275420071278],
            [27.026945809401752, 53.326576472286376],
            [27.024020340576158, 53.329088063888946],
            [27.019997820379388, 53.33159950763741],
            [27.016706668062852, 53.334001620134586],
            [27.012318464375312, 53.33465671795534],
            [27.008478786373303, 53.33465671795534],
            [27.004090582685762, 53.33367406718287],
            [27.000982271665464, 53.33061678643412],
            [26.998239645034403, 53.328978867095486],
            [26.99366859915233, 53.328105284830144],
            [26.98544071746261, 53.330398400929596],
            [26.980138304598597, 53.33301895426996],
            [26.966973694434103, 53.34087964786755],
            [26.95746592007714, 53.345027763373935],
            [26.942107207170523, 53.35244970011945],
            [26.927845545634852, 53.35943387169135],
            [26.916143669434234, 53.364998563781796],
            [26.90919568041187, 53.36772608901697],
            [26.901882007898564, 53.37110797748153],
            [26.89517399841452, 53.37315782810555],
            [26.89517399841452, 53.368060198872854],
            [26.892888475922575, 53.362264045080906],
            [26.89203140498813, 53.35049883839878],
            [26.891745714676745, 53.342141863981226],
            [26.892602785611132, 53.32610553243376],
            [26.893113172254516, 53.31909371810082],
            [26.89688814118182, 53.31740244601332],
            [26.900316424919765, 53.313988986835966],
            [26.899173663673764, 53.31023386590033],
            [26.89660244997208, 53.30477128237101],
            [26.89745952180482, 53.29503932405123],
            [26.89745952180482, 53.290087126181845],
            [26.895459688726135, 53.284451167653],
            [26.893459856545746, 53.2759104197022],
            [26.894316927480133, 53.25711476658881],
            [26.893459856545746, 53.25318372232039],
            [26.887174669692797, 53.25044886922581],
            [26.88346069474511, 53.24925231625713],
            [26.878603959449777, 53.248226672792214],
            [26.87546136512492, 53.24583340855759],
            [26.876604127269218, 53.24241422821251],
            [26.880032411007164, 53.240020638884005],
            [26.88403207536811, 53.23728494491735],
            [26.886888979381183, 53.23489106926286],
            [26.8860319075485, 53.23061595778876],
            [26.882032243187552, 53.22599835792721],
            [26.87717550789222, 53.22411697099204],
            [26.872033081386974, 53.22206445407386],
            [26.870515351663357, 53.21879305256931],
            [26.872300915885717, 53.21531825144888],
            [26.870515351663357, 53.21104118561277],
            [26.86694422232057, 53.208100455224326],
            [26.86203391958651, 53.20596161539589],
            [26.859355572803963, 53.20007925553409],
            [26.858016399412577, 53.1931263350034],
            [26.860694746195122, 53.188044641201145],
            [26.863373092977724, 53.184032352523275],
            [26.86248031041748, 53.17948463802588],
            [26.860248355364206, 53.17520399546777],
            [26.857570008581604, 53.168782231239845],
            [26.85667722602136, 53.16343002610671],
            [26.854891660900876, 53.15807715399524],
            [26.85042774989597, 53.15352668781128],
            [26.84373188204131, 53.14763713310657],
            [26.840160753596763, 53.14335331364299],
            [26.83748240591592, 53.139069066342586],
            [26.839267971036577, 53.13290971254099],
            [26.841946317819122, 53.12969578618646],
            [26.84596383799294, 53.12701733023499],
            [26.848195793944512, 53.12112413993373],
            [26.84774940311337, 53.11817724176984],
            [26.84149992698815, 53.11523014158888],
            [26.83480405913349, 53.11228283938499],
            [26.832125712350944, 53.109067370399714],
            [26.83167932151997, 53.10209969590153],
            [26.830536215007726, 53.09798159991254],
            [26.834036266365104, 53.09410155780944],
            [26.833464885742103, 53.09067026580726],
            [26.83167932151997, 53.086016138091],
            [26.82676901878574, 53.08172617442489],
            [26.824090672003365, 53.077972105142976],
            [26.820965933491493, 53.07421770849339],
            [26.819180369269134, 53.070462984463916],
            [26.818733977539864, 53.06563500076402],
            [26.82230510688271, 53.06268429999528],
            [26.82319788944295, 53.05973339709618],
            [26.820073151829376, 53.056782292600474],
            [26.81248450231277, 53.05329436225168],
            [26.808466981240713, 53.05141612879828],
            [26.806681417018524, 53.04819611017871],
            [26.813823675704157, 53.04551257772755],
            [26.820073151829376, 53.045244214915215],
            [26.82498345366531, 53.04470748535806],
            [26.82900097473737, 53.04229211748543],
            [26.828108192177126, 53.03692414979497],
            [26.821858716051736, 53.03236085172381],
            [26.81605563075732, 53.0291394095168],
            [26.811145328023315, 53.02430679447605],
            [26.808466981240713, 53.0213532633328],
            [26.808913372969982, 53.016519776481516],
            [26.812930893143744, 53.01141717476827],
            [26.817394804148705, 53.008999942484934],
            [26.832572104080214, 53.003896451596574],
            [26.844624664601554, 53.00040424216883],
            [26.85667722602136, 52.99664308494988],
            [26.873640089276932, 52.992344218215464],
            [26.884353477305353, 52.989925917817175],
            [26.89462047360456, 52.988851073815056],
            [26.90220912312111, 52.98831364232433],
            [26.908012208415585, 52.985895115701055],
            [26.908904990975827, 52.9821326946776],
            [26.903548296512497, 52.97702602815741],
            [26.90042355889898, 52.97272520874992],
            [26.90042355889898, 52.96923047774084],
            [26.903994688241767, 52.96519774508903],
            [26.908904990975827, 52.96224016851619],
            [26.909351381806744, 52.9582067837224],
            [26.903548296512497, 52.954441951601325],
            [26.895513256164747, 52.95175258489172],
            [26.895066864435478, 52.948525124521495],
            [26.897745212116376, 52.94422146904543],
            [26.897298820387107, 52.937765183575266],
            [26.895513256164747, 52.93507477993154],
            [26.889263780039357, 52.931577005243355],
            [26.884799868136326, 52.927271664340026],
            [26.87944317457135, 52.921889385607244],
            [26.878550392010936, 52.915698937321906],
            [26.879889565402323, 52.90977681172063],
            [26.884799868136326, 52.90412311754932],
            [26.891049344261717, 52.89846868606145],
            [26.89997716716954, 52.89281351613249],
            [26.910244164366986, 52.886349561259294],
            [26.916493640492376, 52.88311722263427],
            [26.91872559554571, 52.878537663549764],
            [26.91872559554571, 52.87368819165317],
            [26.91872559554571, 52.86533505187333],
            [26.924528680840126, 52.861831643382516],
            [26.929438983574187, 52.858866999991506],
            [26.932563721187705, 52.85455442976132],
            [26.933456503747948, 52.85212842089038],
            [26.933456503747948, 52.84781518160872],
            [26.933456503747948, 52.84296227440285],
            [26.934795677139164, 52.83864812385974],
            [26.93747402392171, 52.83676054856227],
            [26.94684823855897, 52.835142561427574],
            [26.956222452297936, 52.83487289068353],
            [26.962471928423156, 52.83352451401879],
            [26.970060577939933, 52.830288237832065],
            [26.977202836625565, 52.82732143983719],
            [26.9843450953112, 52.827591157463246],
            [26.988809006315932, 52.83001853749266],
            [26.99639765583254, 52.830288237832065],
            [27.007557434692103, 52.82920942588561],
            [27.01827082272058, 52.8289397188488],
            [27.028984209850705, 52.8270517210795],
            [27.03478729514495, 52.824624175283475],
            [27.03880481531877, 52.821656990494375],
            [27.04211682112242, 52.819433100656056],
            [27.04237594466173, 52.81976867625218],
            [27.048179029955975, 52.823275479943334],
            [27.05532128774331, 52.82651227799835],
            [27.061124373037785, 52.827591157463246],
            [27.06782023999415, 52.82786087287201],
            [27.07496249867978, 52.824893909110926],
            [27.079872801413785, 52.82381496321136],
            [27.08746145093056, 52.82354522214314],
            [27.093264536224808, 52.82354522214314],
            [27.100853185741414, 52.821926742741084],
            [27.10620987930656, 52.8194989106093],
            [27.110227399480323, 52.816531375845045],
            [27.114244920552437, 52.813293834297326],
            [27.1182624407262, 52.812214599831236],
            [27.125404698513705, 52.81275422041358],
            [27.132100566368194, 52.816531375845045],
            [27.138350042493585, 52.82300573606898],
            [27.14459951861903, 52.827591157463246],
            [27.14995621218401, 52.83109732934656],
            [27.155759297478426, 52.83649088840639],
            [27.157991252531758, 52.841344518310564],
            [27.1562056883094, 52.84673680441904],
            [27.150402603015152, 52.85158928921328],
            [27.144153126889762, 52.85482397829435],
            [27.137010869102426, 52.85913652119933],
            [27.13567169571104, 52.864257109908294],
            [27.14192117183643, 52.86856871600105],
            [27.149509821353035, 52.87180213911114],
            [27.16022320848333, 52.87557416164401],
            [27.16691907633782, 52.877190642234325],
            [27.178971636859387, 52.878807063117506],
            [27.18298915703315, 52.884464059861045],
            [27.179864419419573, 52.888773657629656],
            [27.17316855246321, 52.89416005214673],
            [27.16647268460855, 52.90116136432937],
            [27.16647268460855, 52.90520006827916],
            [27.170490204782368, 52.91004601664224],
            [27.18120359281096, 52.91166121212183],
            [27.188792242327565, 52.91300716252721],
            [27.196827282675144, 52.915698937321906],
            [27.20263036796956, 52.918659696748875],
            [27.203523150529804, 52.92458060834332],
            [27.200844803747202, 52.9286171290679],
            [27.196827282675144, 52.93372951538612],
            [27.19639929964427, 52.93630905514942],
          ],
        ],
      },
      properties: {
        shapeName: "Kapyl",
        shapeISO: "",
        shapeID: "67162791B49789732024983",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
